export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/pinLocationGray.df2d0369.svg","height":20,"width":16,"blurWidth":0,"blurHeight":0};